import ConversationList from './Conversation.list'
import ConversationEdit from './Conversation.edit'

const resource = {
  list: ConversationList,
  edit: ConversationEdit,
}

export default resource
